// extracted by mini-css-extract-plugin
export default {"dashboardWidget":"RootDashboardWidget_dashboardWidget__8C-aO","dashboardWidgetContent":"RootDashboardWidget_dashboardWidgetContent__vT40l"};